export default "__VITE_ASSET__B6XUUq$l__"